import { StatsigClient } from '@statsig/js-client';
import { runStatsigSessionReplay } from '@statsig/session-replay';

(async () => {
  const config = window.__STATSIG_CONFIG__;

  if (!config?.sessionReplay) { return; }

  const client = new StatsigClient(
    config.clientKey,
    {
      userID: config.userID,
      email: config.email,
      ...(config.customIDs && { customIDs: config.customIDs }),
      ...(config.custom && { custom: config.custom }),
    },
    {
      environment: { tier: config.tier },
      ...(config.initializeValues && { initializeValues: config.initializeValues }),
      networkConfig: {
        initializeUrl: 'https://featureassets.org/v1/initialize',
        logEventUrl: 'https://prodregistryv2.org/v1/rgstr',
      },
    }
  );

  runStatsigSessionReplay(client);

  try {
    await client.initializeAsync();
  } catch (_err) {
    // Statsig initialization failure is non-critical; session replay will not run.
  }
})();
